<template>
  	<v-dialog v-model="open" max-width="600" persistent>
		<v-card class="background-2 round-card">
	  		<v-card-title class="pa-3">
				<p class="pl-2 pl-xl-3">Generazione Barcode</p>
				<v-spacer></v-spacer>
	  		</v-card-title>
	  		<v-divider></v-divider>
	  		<v-card-text class="pt-4 body-2">Vuoi generare i barcode per tutti i prodotti selezionati?</v-card-text>
	  		<v-card-text class="body-2">Elementi selezionati: <span class="body-1 font-weight-medium">{{ selectedIds.length }}</span></v-card-text>
	  
			<v-row class="mx-0 px-4">
				<v-col>
					<p class="pb-2">Seleziona il prefisso da utilizzare:</p>
					<v-select
						v-model="selectedPrefix"
						:items="barcodePrefixes"
						outlined
						dense
						label="Prefisso"
						:menu-props="{'offset-y': true}"
						:disabled="loading"
						:error-messages="prefixError"
						@input="prefixError = ''"
					></v-select>
					
					<v-checkbox
						v-model="replaceExisting"
						label="Sostituisci i barcode esistenti"
						color="primary"
						hide-details
						class="mt-2"
					></v-checkbox>
				</v-col>
			</v-row>
	  
			<v-row class="mx-0 px-4 pb-6">
				<v-col class="pt-0">
					<small>
						<p><strong>Informazioni:</strong></p>
						<ul>
							<li>Verrà generato un barcode univoco per ogni prodotto selezionato</li>
							<li>I barcode saranno nel formato EAN-13 con il prefisso scelto</li>
							<li v-if="replaceExisting">I barcode esistenti verranno sovrascritti</li>
							<li v-else>I prodotti che hanno già un barcode verranno saltati</li>
						</ul>
					</small>
				</v-col>
			</v-row>
	  
			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text color="info" @click.native="$emit('close')">Annulla</v-btn>
				<v-btn text color="primary" @click.native="validatePrefix()" :loading="loading">Procedi</v-btn>
			</v-card-actions>
		</v-card>

		<confirm-dialog
			:confirmModel="confirmGenerateBarcodes"
			mainTitle="Sei sicuro di generare questi barcode?"
			secondTitle="Una volta premuto 'Genera' saranno generati i barcode per tutti i prodotti selezionati."
			@update:confirmModel="confirmGenerateBarcodes = false"
			:atConfirm="generateBarcodes"
			:confirm="{color: 'info', label: 'genera'}"
		></confirm-dialog>
  </v-dialog>
</template>

<script>
export default {
	name: 'generate-barcode-dialog',
	props: {
		params: Object,
		selected: Array,
		selectedIds: Array,
		modelDef: String,
		open: Boolean,
		button: Object,
	},
	
	data() {
		return {
			selectedPrefix: null,
			prefixError: '',
			loading: false,
			confirmGenerateBarcodes: false,
			replaceExisting: true,
		}
	},

	computed: {
		barcodePrefixes() {
			return this.$store.getters.getSetting('barcode_prefixes') || []
		}
	},

	methods: {
		validatePrefix() {
			if (!this.selectedPrefix) {
				this.prefixError = 'Seleziona un prefisso per procedere'
				return
			}
			this.confirmGenerateBarcodes = true
		},

		generateBarcodes() {
			this.loading = true
			
			// Single API call with all IDs
			this.axios.post('products-generate-barcode/', {
				ids: this.selectedIds,
				prefix: this.selectedPrefix,
				replace_existing: this.replaceExisting,
			}).then(response => {
				this.loading = false
				this.$store.commit('setSnackbar', {
					timeout: 6000,
					text: `Barcode generati con successo per ${this.selectedIds.length} prodotti`,
					value: true,
					color: 'success'
				})
				this.$emit('close')
				this.$eventBusUtility.$emit('refreshTable_products')
			}).catch(error => {
				this.loading = false
				this.$store.commit('setSnackbar', {
					timeout: 6000,
					text: 'Errore durante la generazione dei barcode',
					value: true,
					color: 'error'
				})
			})
		}
	}
}
</script>
